import Animated, { FadeIn, FadeOut } from "react-native-reanimated";
import { Adapt, Sheet, Theme } from "tamagui";

import CuraiConversation from "@/conversation/CuraiConversation";
import {
  useCurrentConversationId,
  useCurrentConversationType,
  useNoriConversationId,
} from "@/hooks/conversation";
import { usePropagatedRouter } from "@/hooks/usePropagatedRouter";

export default function CuraiConversationModal() {
  const conversationId = useCurrentConversationId();
  const noriConversationId = useNoriConversationId();
  const { data: conversationType } = useCurrentConversationType();
  const router = usePropagatedRouter();
  return (
    <Adapt when="maxLg">
      <Sheet
        modal
        dismissOnOverlayPress={false}
        unmountChildrenWhenHidden
        snapPoints={[98]}
        open={conversationType === "curai"}
        disableDrag
        onOpenChange={(open: boolean) => {
          if (!open) {
            router.navigate(`/conversation/${noriConversationId}`);
          }
        }}
      >
        <Sheet.Overlay
          transition="standard"
          backgroundColor="$fillOverlay"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />
        <Sheet.Frame>
          <Theme name="clinic">
            <Animated.View
              style={{ flex: 1 }}
              entering={FadeIn.duration(150)}
              exiting={FadeOut.duration(150)}
            >
              {conversationId && (
                <CuraiConversation conversationId={conversationId} />
              )}
            </Animated.View>
          </Theme>
        </Sheet.Frame>
      </Sheet>
    </Adapt>
  );
}
